// Detects the AppSync/DynamoDB "conditional request failed" error.
//
// Recap rows now use a deterministic id (see getDeterministicRecapId), and the
// `createRecapInfo` resolver enforces attribute_not_exists(id). When two
// creators race for the same budget line, the loser's create is rejected with a
// ConditionalCheckFailedException — this is now an EXPECTED, benign outcome.
//
// Several client create paths react to a failed create by deleting every recap
// row for the quote (rollback-by-wipe). A benign conditional failure must NOT
// reach those catch blocks, or it would turn a harmless duplicate into mass
// data loss. Callers use this to swallow only the conditional failure and
// rethrow everything else.
export function isRecapConditionalCheckError(err: unknown): boolean {
	const anyErr = err as
		| { errors?: { errorType?: string; message?: string }[] }
		| { response?: { errors?: { errorType?: string; message?: string }[] } }
		| undefined
	const errors = (anyErr as any)?.errors ?? (anyErr as any)?.response?.errors
	if (!Array.isArray(errors)) return false
	return errors.some(
		(e) =>
			(typeof e?.errorType === 'string' &&
				e.errorType.includes('ConditionalCheckFailed')) ||
			(typeof e?.message === 'string' &&
				/conditional request failed/i.test(e.message))
	)
}
